import { render, staticRenderFns } from "./inventory-options-drawer.vue?vue&type=template&id=6fdbd271&scoped=true&"
import script from "./inventory-options-drawer.vue?vue&type=script&lang=js&"
export * from "./inventory-options-drawer.vue?vue&type=script&lang=js&"
import style0 from "./inventory-options-drawer.vue?vue&type=style&index=0&id=6fdbd271&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdbd271",
  null
  
)

export default component.exports